export default __webpack_public_path__ + "static/media/instrucciones-2.e79a00bb.jpg";